module.exports = __webpack_public_path__ + "static/img/policy.5aebaa7.png";